import ApplicationSerializer from 'lumen/serializers/application';

export default class CostSettingCostSerializer extends ApplicationSerializer {
  attrs = {
    commissionType: { key: 'rate_structure' },
    costType: { key: 'category' },
    // Costs are written nested inside their profile.
    profile: { serialize: false },
  };
}
